import { instantDate, isAfter } from '@lingoda/dates';
import { isPointsChallengeTextsEnforced } from '@lingoda/local-feature-flags';

// A day before the first points challenge (October 2026), so users in timezones west of the
// challenge's own can't fall back to legacy copy. QA can force the new copy via dev flag.
// Device-local midnight on 30 Sep 2026 (the month is 0-based: 8 = September).
const POINTS_SYSTEM_START_DATE = new Date(2026, 8, 30);

export const isPointsChallenge = (startDate: string) => {
    return (
        isPointsChallengeTextsEnforced() ||
        isAfter(instantDate(startDate), POINTS_SYSTEM_START_DATE)
    );
};
